import React from "react";

const Icon = ({ Name, props }) => {
  return <i {...props} className={`fa-solid fa-${Name}`}></i>;
};

export default Icon;
